import { Button, Stack } from '@mui/material';
import Layout from "../../../Frames/Layout";
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import ActionsTable from './ActionsTable';

export default function List(){

    return (
        <Layout title="Actions DPC" tab="actions" menu="dpc">
            <Stack direction="row" flexWrap="wrap" sx={{ mb: 1 }}>
                <Button
                    startIcon={<Add />}
                    component={Link}
                    to="/dpc/actions/new"
                >
                    Action
                </Button>
            </Stack>

            <ActionsTable />
        </Layout>
    );
}
